<template lang='pug'>
  div.pa-4(v-if='hasScreens')
    span.text-subtitle-1.font-weight-light Screenshots
    v-item-group(v-model='activeImageIndex')
      v-row
        v-col(v-for='img in images' :key='img.url' cols='12' sm='6' md='4' lg='3')
          v-item(v-slot:default='{active, toggle}')
            v-card.d-flex.align-center(:color="active ? 'primary' : ''" dark='' height='200' @click='toggleAndMaybeOpen(img.url, toggle)' :elevation='active ? "16" : "0"')
              v-tooltip(v-if='img.title' bottom)
                template(v-slot:activator='{on}')
                  v-img(v-on='on' :src='img.url' height='200')
                span {{img.title}}
              v-img(v-if='!img.title' :src='img.url' height='200')
    v-row(v-if='!$vuetify.breakpoint.xsOnly').mt-5
      v-scroll-y-transition
        v-img.clickable(v-if='activeImage' :src='activeImage' contain @click='openImage')
</template>

<script>
import _ from 'lodash';

export default {
  name: 'BionicMetricsScreens',
  props: {
    testRun: {
      type: Object,
      required: true
    },
    test: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    hasDefaultScreens() {
      return this.testRun && !this.testRun.loadTest;
    },
    activeImage() {
      if (!_.isNumber(this.activeImageIndex)) return null;
      return this.images[this.activeImageIndex].url;
    },
    images() {
      const customScreens = _.get(this.test, 'screens') || [];
      const defaultScreen = this.hasDefaultScreens ? {url: this.getImageUrl(this.testRun, this.test, this.index), title: null} : null;
      return defaultScreen ? [...customScreens, {url: this.getImageUrl(this.testRun, this.test, this.index), title: null}] : customScreens;
    },
    hasScreens() {
      return this.images.length;
    }
  },
  methods: {
    toggleAndMaybeOpen(url, toggle) {
      toggle();
      if (this.$vuetify.breakpoint.xsOnly) this.openImage();
    },
    openImage() {
      window.open(this.activeImage, '_blank');
    },
    getBaseUrl(testRun) {
      return `${process.env.VUE_APP_SCREENS_URL}/${testRun.testSuiteGuid}/${testRun.guid}${testRun.agentGuid ? `/${testRun.agentGuid}` : ''}`;
    },
    getImageUrl(testRun, test, i) {
      if (test.rerun) return `${this.getBaseUrl(testRun)}/${i}_${test.rerun}.png`;
      return `${this.getBaseUrl(testRun)}/${i}.png`;
    },
    hasScreen(test) {
      return test.status !== 'NO_DATA' && !test.isRunning;
    }
  },
  data() {
    return {
      activeImageIndex: null
    };
  }
};
</script>

<style scoped>
</style>
